import CalendarHubComponent from '../CalendarHubComponent.vue';

export default [
    {
        path: '/my-calendar',
        name: 'MyCalendar',
        meta: {
            layout: 'default',
            requiresAuth: true,
        },
        component: CalendarHubComponent,
    },
];
